import { render, staticRenderFns } from "./wysiwyg.vue?vue&type=template&id=28eb7566&scoped=true&"
import script from "./wysiwyg.vue?vue&type=script&lang=js&"
export * from "./wysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./wysiwyg.vue?vue&type=style&index=0&id=28eb7566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb7566",
  null
  
)

export default component.exports